import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "./Hero";
import WelcomePage from "./WelcomePage";
import HowItWorksContent from "./HowItWorksContent";
import About from "./About";
import Service from "./Service";
import NewPatientss from "./NewPatientss";
import Contact from "./Contact";

const MainPage = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === '/registration') {
            setTimeout(() => {
                const section = document.getElementById('contact');
                if (section) {
                    // Instant scroll interaction
                    document.documentElement.style.scrollBehavior = 'auto';
                    section.scrollIntoView({ behavior: 'auto', block: 'center' });
                    document.documentElement.style.scrollBehavior = '';
                }
            }, 100);
        }
    }, [location]);

    return (
        <>
            <Hero />
            <WelcomePage />

            {/* === 'HOW IT WORKS' SECTION ANCHOR & COMPONENT === */}
            <div id="howItWorks">
                <HowItWorksContent />
            </div>
            {/* =========================================== */}

            <div id="about">
                <About />
            </div>
            <div id="services">
                <Service />
            </div>
            <div id="newPatients">
                <NewPatientss />
            </div>
            <div id="contact">
                <Contact />
            </div>
        </>
    );
};

export default MainPage;
